import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { LINHAS_MIX as LINHAS } from "@/constants/linhasMix";

// LOTE X-1 F1: modal de 3 campos para o vendedor abrir uma oportunidade de
// Ampliação de mix em um cliente que já é da MPires. Fluxo propositalmente
// enxuto: cliente (fixo), linhas (chips múltipla escolha), valor estimado
// opcional. Entra em Prospecção com tipo="ampliacao_mix".
export default function AmpliarMixModal({ open, onOpenChange, cliente }) {
  const navigate = useNavigate();
  const [linhas, setLinhas] = useState([]);
  const [valor, setValor] = useState("");
  const [busy, setBusy] = useState(false);
  if (!open) return null;

  const toggle = (l) => setLinhas((s) => (s.includes(l) ? s.filter((x) => x !== l) : [...s, l]));

  const criar = async () => {
    if (!linhas.length) { toast.error("Marque pelo menos uma linha"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/deals/ampliar-mix", {
        cliente_id: cliente.id, linhas,
        valor_estimado: Number(String(valor).replace(/[^\d,]/g, "").replace(",", ".")) || 0,
      });
      toast.success("Oportunidade de ampliação criada");
      onOpenChange(false);
      navigate(`/deal/${data.id}`);
    } catch (e) {
      toast.error(errMsg(e) || "Falha ao criar");
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-end md:items-center justify-center p-0 md:p-4" data-testid="ampliar-mix-modal">
      <div className="bg-white w-full md:max-w-md rounded-t-2xl md:rounded-2xl p-5 max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-lg font-semibold text-navy">Ampliar mix</h2>
          <button onClick={() => onOpenChange(false)} data-testid="ampliar-mix-close" className="text-slate-400 hover:text-navy text-xl leading-none" aria-label="Fechar">×</button>
        </div>
        <div className="mb-4">
          <div className="text-xs font-medium text-muted-foreground">Cliente</div>
          <div className="text-sm font-semibold text-navy mt-0.5">{cliente?.nome}</div>
          {cliente?.secondary && (
            <div className="text-[11px] text-muted-foreground truncate">{cliente.secondary}</div>
          )}
        </div>
        <div className="mb-4">
          <div className="text-xs font-medium text-muted-foreground mb-1.5">Linhas a oferecer *</div>
          <div className="flex flex-wrap gap-1.5" data-testid="ampliar-mix-linhas">
            {LINHAS.map((l) => (
              <button key={l} type="button" onClick={() => toggle(l)}
                data-testid={`ampliar-mix-linha-${l}`}
                className={`px-2.5 py-1 rounded-full border text-xs font-semibold transition-colors ${linhas.includes(l) ? "bg-brand text-white border-brand" : "bg-white text-slate-600 border-input hover:border-brand/40"}`}>
                {l}
              </button>
            ))}
          </div>
        </div>
        <div className="mb-5">
          <label className="text-xs font-medium text-muted-foreground">Valor estimado (opcional)</label>
          <input value={valor} onChange={(e) => setValor(e.target.value)}
            placeholder="R$ 0,00" inputMode="decimal"
            data-testid="ampliar-mix-valor"
            className="w-full mt-1 h-10 rounded-lg border border-input bg-white px-3 text-sm" />
        </div>
        <div className="flex gap-2">
          <button onClick={() => onOpenChange(false)} disabled={busy}
            data-testid="ampliar-mix-cancelar"
            className="flex-1 h-10 rounded-lg border border-input bg-white text-slate-600 text-sm font-semibold">
            Cancelar
          </button>
          <button onClick={criar} disabled={busy}
            data-testid="ampliar-mix-criar"
            className="flex-1 h-10 rounded-lg bg-brand text-white text-sm font-semibold disabled:opacity-60">
            {busy ? "Criando…" : "Criar oportunidade"}
          </button>
        </div>
      </div>
    </div>
  );
}
